import {GET} from '../constants/API_CONSTANTS';
import {API_GET_INVITE_A_BITE_INFO} from '../constants/API_ENDPOINTS';
import {request} from '../utils/request';

const getInviteABiteInfoApi = async (locationId) => {
  return request(GET, API_GET_INVITE_A_BITE_INFO(locationId));
};

export default getInviteABiteInfoApi;
